import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { CardViewsStat } from "../models/cardViewsStat";
import { DownloadedStat } from "../models/downloadedStat";
import { ContentStat } from "../models/ContentStat";
import { TopContentStat } from "../models/TopContentStat";
import { TopPerformers } from "../models/TopPerformers";

@Injectable({
  providedIn: 'root'
})
export class InsightsService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  trackLinkTap(userCardContentId: bigint): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/insights/content-tap`, { userCardContentId });
  }

  getCardViewStat(startDate: string | null | undefined, endDate: string | null | undefined, isTeam: boolean): Observable<CardViewsStat> {
    const params = this.isTeamParam(this.buildDateParams(startDate, endDate), isTeam);
    return this.http.get<CardViewsStat>(`${this.apiUrl}/insights/card-views`, { params });
  }

  getDownloadedStat(startDate: string | null | undefined, endDate: string | null | undefined, isTeam: boolean): Observable<DownloadedStat> {
    const params = this.isTeamParam(this.buildDateParams(startDate, endDate), isTeam);
    return this.http.get<DownloadedStat>(`${this.apiUrl}/insights/downloaded`, { params });
  }

  getContentStat(startDate: string | null | undefined, endDate: string | null | undefined, isTeam: boolean): Observable<ContentStat> {
    const params = this.isTeamParam(this.buildDateParams(startDate, endDate), isTeam);
    return this.http.get<ContentStat>(`${this.apiUrl}/insights/content-tap`, { params });
  }

  getTopContentStat(startDate: string | null | undefined, endDate: string | null | undefined, isTeam: boolean): Observable<TopContentStat[]> {
    const params = this.isTeamParam(this.buildDateParams(startDate, endDate), isTeam);
    return this.http.get<TopContentStat[]>(`${this.apiUrl}/insights/top-contents`, { params });
  }

  getTopPerformers(startDate?: string | null, endDate?: string | null): Observable<TopPerformers[]> {
    const params = this.buildDateParams(startDate, endDate);
    return this.http.get<TopPerformers[]>(`${this.apiUrl}/insights/top-performers`, { params });
  }

  private buildDateParams(startDate?: string | null, endDate?: string | null): HttpParams {
    let params = new HttpParams();
    if (startDate && endDate) {
      params = params.set('startDate', startDate);
      params = params.set('endDate', endDate);
    }
    return params;
  }

  private isTeamParam(params: HttpParams, isTeam: boolean): HttpParams {
    return params.set('isTeam', isTeam.toString());
  }
}
